import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Input, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { Server } from '../../clients/aasServerClient.generated';
import { isLoading } from '../../stores/navigation/selectors';
import { fetchTableServers,fetchTableServersNF } from '../../stores/servers/actionCreators';
import { getTableServers } from '../../stores/servers/selectors';
import { RootState } from '../../stores/store';
import DashboardContainer from '../dashboard/DashboardContainer';
import ViewContainer from '../layout/ViewContainer';
import Table from '../table/Table';
import TableBody from '../table/TableBody';
import TableColumn from '../table/TableColumn';
import TableHead from '../table/TableHead';
import TableToolbar from '../table/TableToolbar';
import ServerTableHead from './ServersTableHead';
import ServerTableRow from './ServersTableRow';
import ServersToolbar from './ServersToolbar';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    servers: Server[];
    loading: boolean;
    lState : RootState;
    fetchServers: () => void;
    fetchServersNF: () => void;
}

export class ServersPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.props.lState.tables['servers'].search ='';
        this.props.fetchServersNF();       
    }

    public render() {
        const t = this.props.translate;
        return (
            <ViewContainer className="table-view">
                <div>
                    <h1>{t('servers.header.servers')}</h1>
                    {this.props.loading ? <Spinner /> : null}
                </div>
                <Table
                    toolbar={<ServersToolbar />}
                    refresh={this.props.fetchServers}
                    tableKey="servers"
                >
                    <ServerTableHead
                        refresh={this.props.fetchServers}
                        ids={this.props.servers.map((u) => u.id)}
                    />
                    <TableBody>
                        {this.props.servers.map((server, i) => (
                            <ServerTableRow key={i} server={server} />
                        ))}
                    </TableBody>
                </Table>
            </ViewContainer >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    loading: isLoading(state),
    servers: getTableServers(state),
    lState : state,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchServers: () => dispatch(fetchTableServers()),
    fetchServersNF: () => dispatch(fetchTableServersNF()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ServersPage)));
